module.exports = __webpack_public_path__ + "img/formato.8411b3bc.png";